import { postCustomClaim } from './PostCustomClaim';

export const authServices = {
  postCustomClaim,
};
